<template>
  <v-server-table
    :url="`fundsfiles/${id}/`"
    :columns="columns"
    :options="options"
  >
    <template v-slot:gross_amount="{ row }">
      {{ Number(row.gross_amount).toFixed(2) }}
    </template>

    <template v-slot:net_amount="{ row }">
      {{ Number(row.net_amount).toFixed(2) }}
    </template>

    <template v-slot:tax_deductions_pct="{ row }">
      {{ getValue(row.tax_deductions_pct) }}
    </template>

    <template v-slot:other_deductions_pct="{ row }">
      {{ getValue(row.other_deductions_pct) }}
    </template>

    <template v-slot:additions_pct="{ row }">
      {{ getValue(row.additions_pct) }}
    </template>

    <template v-slot:actions="{ row }">
      <span
        class="ml-3"
        @click="goToFile(row)"
      >
        <i class="fas fa-level-up-alt rotate-90" />
      </span>
    </template>
  </v-server-table>
</template>

<script>
import { capitalize } from "lodash"
import { doRequest } from "@/assets/libs/utils"

export default {
  name: "FundsTable",
  props: {
    id: {
      type: Number
    }
  },

  data () {
    return {
      columns: [
        "actions",
        "name",
        "proprietary_id",
        "gross_amount",
        "tax_deductions_pct",
        "other_deductions_pct",
        "additions_pct",
        "net_amount"
      ],
      options: {
        skin: "table-striped",
        headings: {
          actions: "",
          name: capitalize(this.$t("name")),
          proprietary_id: capitalize(this.$t("proprietary_id")),
          gross_amount: capitalize(this.$t("gross_amount")),
          tax_deductions_pct: capitalize(this.$t("tax_deductions_pct")),
          other_deductions_pct: capitalize(this.$t("other_deductions_pct")),
          additions_pct: capitalize(this.$t("additions_pct")),
          net_amount: capitalize(this.$t("net_amount")),
        },
        rowClassCallback: () => {
          return "table-sub-class"
        },
        requestFunction (params) {
          return doRequest(this.url, params)
        },
        responseAdapter: resp => ({
          count: resp.data.length,
          data: resp.data
        })
      }
    }
  },
  computed: {},
  methods: {
    getValue: val => val ? Number(val).toFixed(2) + "%" : "" 
  }
}
</script>
